import React, { Component } from "react";
import Panel from "../../../components";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Checkbox,
  HelpBlock,
  Alert
} from "react-bootstrap";
import { createHashHistory } from "history";

import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import loader from "../../../style/loader/loader.scss";
import { withRouter, Link } from "react-router-dom";
import { bindActionCreators, compose } from "redux";
import isEmpty from "lodash.isempty";
import DateTimePicker from "react-datetime-picker";
import moment from "moment";

import FormValidator from "../../../_helpers/FormValidator";
import NumberFormat from "react-number-format";

import "rc-color-picker/assets/index.css";
import ColorPicker from "rc-color-picker";
import noPreview from "../../../img/no-preview.jpg";
import {
  merchantActions,
  get_merchant_details_id
} from "../../../redux/actions/merchantActions";
import {
  renderAlert,
  clearAlert,
  alertsActions
} from "../../../redux/actions/alertsActions";
import {aclUtil} from "../../util"

const history = createHashHistory();

const FederalTaxClassification = [
  "Individual/sole proprietor",
  "S Corporation",
  "Trust/estate",
  "C Corporation",
  "Partnership",
  "Other"
];

const propTypes = {
  get_merchant_details_id: PropTypes.func.isRequired
};

class W9Info extends React.Component {
  constructor(props) {
  const viewLink = (props.match && props.match.params) && `merchant/w9info/${props.match.params.merchantID}`
    super(props);

    this.validator = new FormValidator([
      {
        field: "name",
        method: "isEmpty",
        validWhen: false,
        message: "Field is required."
      },
      {
        field: "federal_tax_classification",
        method: this.checkFederalTax, // notice that we are passing a custom function here
        validWhen: true,
        message: "Please Choose Tax Classification."
      },
      {
        field: "ssn",
        method: this.checkssn_tinNumber, // notice that we are passing a custom function here
        validWhen: true,
        message: "Field is required."
      },
      {
        field: "address",
        method: "isEmpty", // notice that we are passing a custom function here
        validWhen: false,
        message: "Field is required."
      },
      {
        field: "city",
        method: "isEmpty", // notice that we are passing a custom function here
        validWhen: false,
        message: "Field is required."
      },
      {
        field: "stateName",
        method: "isEmpty", // notice that we are passing a custom function here
        validWhen: false,
        message: "Field is required."
      },
      {
        field: "zipcode",
        method: "isEmpty", // notice that we are passing a custom function here
        validWhen: false,
        message: "Field is required."
      },
      {
        field: "wTaxFile",
        method: this.checkDisplayImage, // notice that we are passing a custom function here
        validWhen: true,
        message: "Field is required."
      }
    ]);

    this.state = {
      menuKey: 'W9INFO',
      path: ["Home", "Manage Merchant", "W9 Info"],
      links:["home", "merchantList",viewLink],
      name: "",
      business_name: "",
      federal_tax_classification: [],
      expemt_payee: "",
      ddtax: "",
      is_ddtax_checked: 0,
      exempt_report: "",
      ssn: "",
      tin: "",
      address: "",
      city: "",
      stateName: "",
      zipcode: "",
      account_no: "",
      requestersName: "",
      wTaxFile: "",
      msg_status: "hide",
      alertMessage: "",
      show: false,
      msgType: "",
      loading: false,
      message: "",
      w9FileImage: "",
      w9DocFile: "",
      validation: this.validator.valid()
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.toggleCheckbox = this.toggleCheckbox.bind(this);
    this.submitted = false;
  }

  checkFederalTax = (checkTax, state) => {
    return this.state.federal_tax_classification.length > 0 ? true : false;
  };

  checkDisplayImage = (displayImage, state) => {
    let validImage = [
      "image/jpeg",
      "image/png",
      "image/tiff",
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/msword"
    ];
    if (
      state.merchantWTaxFile == "" ||
      (displayImage && validImage.indexOf(state.wTaxFile.type) < 0)
    ) {
      return false;
    } else {
      return true;
    }
  };

  checkssn_tinNumber = (ssn, state) => {
    if (state.ssn == "" && state.tin == "") {
      return false;
    } else {
      return true;
    }
  };

  checkDateRange = (checkDate, state) => {
    let startedAt = new Date(state.started_at);
    let endedAt = new Date(state.ended_at);
    let currDate = new Date();
    if (startedAt < currDate || endedAt < currDate || endedAt <= startedAt) {
      return false;
    } else {
      return true;
    }
  };

  handleInputChange = event => {
    if (event.target.name == "is_ddtax_checked") {
      if (this.state.is_ddtax_checked == 1) {
        this.setState({
          is_ddtax_checked: 0,
          ddtax: ""
        });
      } else {
        this.setState({
          is_ddtax_checked: 1,
          ddtax: "C_CORPORATION"
        });
      }
    } else {
      this.setState({
        [event.target.name]: event.target.value
      });
    }
  };

  onDateChange = (dtype, date) => {
    this.setState({
      [dtype]: date
    });
  };

  componentDidMount() {
    if (this.props.match && this.props.match.params.merchantID) {
      this.setState({ merchantID: this.props.match.params.merchantID });
      const {
        actions: { get_merchant_details_id }
      } = this.props;
      get_merchant_details_id(this.props.match.params.merchantID);
    }
  }

  getFileExtension(filename) {
    return filename.split(".").pop();
  }

  componentWillReceiveProps(nextProps) {
    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.props.history.push("/restrictedAccess");
    }
    if (
      nextProps.merchantDetails &&
      nextProps.merchantDetails.mechantTaxInfoSetting
    ) {
      this.setState({
        loading: false
      });
      this.setState(
        JSON.parse(nextProps.merchantDetails.mechantTaxInfoSetting)
      );
      this.setState({
        merchantWTaxFile: nextProps.merchantDetails.merchantWTaxFile
      });
      let imgExt = ["jpeg", "jpg", "png", "JPEG", "PNG"];
      if (
        nextProps.merchantDetails.merchantWTaxFile &&
        imgExt.indexOf(
          this.getFileExtension(nextProps.merchantDetails.merchantWTaxFile)
        ) >= 0
      ) {
        this.setState({
          w9DocFileUrl: nextProps.merchantDetails.merchantWTaxFile,
          w9DocFile: nextProps.merchantDetails.merchantWTaxFile
        });
      } else {
        this.setState({
          w9DocFileUrl: nextProps.merchantDetails.merchantWTaxFile,
          w9DocFile: noPreview
        });
      }
    }
    if (nextProps.updatedMerchant && nextProps.updatedMerchant.response) {
      this.setState({
        msgType: nextProps.updatedMerchant.response,
        message: nextProps.updatedMerchant.message,
        loading: false
      });
    }
    if (nextProps.error) {
      this.setState({
        msgType: "error",
        message: nextProps.error,
        loading: false
      });
    }

    setTimeout(
      function() {
        this.setState({
          msgType: "",
          message: ""
        });
      }.bind(this),
      5000
    );
  }

  handleFormSubmit = event => {
    event.preventDefault();
    const validation = this.validator.validate(this.state);
    this.setState({ validation });
    this.submitted = true;
    if (validation.isValid) {
      let formData = new FormData();
      formData.append(
        "mechantTaxInfoSetting",
        JSON.stringify({
          name: this.state.name,
          business_name: this.state.business_name,
          federal_tax_classification: this.state.federal_tax_classification,
          ddtax: this.state.ddtax,
          expemt_payee: this.state.expemt_payee,
          exempt_report: this.state.exempt_report,
          ssn: this.state.ssn,
          tin: this.state.tin,
          address: this.state.address,
          city: this.state.city,
          stateName: this.state.stateName,
          zipcode: this.state.zipcode,
          account_no: this.state.account_no,
          requestersName: this.state.requestersName
        })
      );
      formData.append("merchantID", this.state.merchantID);
      if (this.state.wTaxFile) {
        formData.append("merchantWTaxFile", this.state.wTaxFile);
      }
      const {
        actions: { update_merchant }
      } = this.props;
      update_merchant(formData);
      this.setState({
        loading: true
      });
    } else {
      this.setState({
        loading: false
      });
    }
  };

  handleselectedFile = event => {
    this.setState({
      wTaxFile: event.target.files[0]
    });
    this.readURL(event);
  };

  renderAlert() {
    if (this.state.msgType && this.state.message) {
      let msgClass =
        this.state.msgType == "error"
          ? "alert alert-danger"
          : "alert alert-" + this.state.msgType;
      return (
        <div className={msgClass}>
          <strong>{this.state.msgType.toUpperCase()} :</strong>{" "}
          {this.state.message}
        </div>
      );
    }
  }

  toggleCheckbox = event => {
    let checkValue = event.target.value;
    let checkIndex = this.state.federal_tax_classification.indexOf(checkValue);
    if (checkIndex >= 0) {
      this.state.federal_tax_classification.splice(checkIndex, 1);
    } else {
      this.state.federal_tax_classification.push(checkValue);
    }
  };

  readURL(event) {
    let fileTax = event.target.files[0];
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();

      let validImage = ["image/jpeg", "image/png"];
      if (validImage.indexOf(fileTax.type) >= 0) {
        reader.onload = function(e) {
          document.getElementById("w9FileImage").src = e.target.result;
        };

        reader.readAsDataURL(event.target.files[0]);
        this.setState({ w9DocFileUrl: "" });
      } else {
        this.setState({ w9DocFileUrl: "", w9DocFile: "" });
      }
    }
  }

  render() {
    let validation = this.submitted // if the form has been submitted at least once
      ? this.validator.validate(this.state) // then check validity every time we render
      : this.state.validation; // otherwise just use what's in state
    let federalSetting;
    federalSetting = FederalTaxClassification.map((fval, findex) => (
      <Checkbox
        inline
        name="federal_tax_classification"
        onChange={this.toggleCheckbox}
        key={fval}
        value={fval}
      >
        {fval}
      </Checkbox>
    ));
    return (
      <div className="col-lg-12 add-sub-admin">
        {this.state.loading === true ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}

        <form>
          {this.renderAlert()}
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links} />
            </div>
          </div>

          <div className="panel">
            <header className="panel-heading">W9 Information</header>

            {this.state.show &&
              this.state.alertMessage !== "" && (
                <div className="col-lg-12">
                  <Alert
                    bsStyle={this.state.msgType}
                    onDismiss={this.handleDismiss}
                  >
                    <strong>{this.state.msgType}:</strong>{" "}
                    {this.state.alertMessage}
                  </Alert>
                </div>
              )}

            <div className="panel-body">
              <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={6} xs={12}>
                    <FormGroup
                      className={validation.name.isInvalid && "has-error"}
                    >
                      <ControlLabel>
                        {" "}
                        <span style={{ color: "red" }}>*</span>Name (as shown on
                        income tax return)
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.name}
                        placeholder="Name"
                        onChange={this.handleInputChange}
                        name="name"
                      />
                    </FormGroup>

                    <FormGroup
                      className={
                        validation.federal_tax_classification.isInvalid &&
                        "has-error"
                      }
                    >
                      <ControlLabel>
                        {" "}
                        <span style={{ color: "red" }}>*</span>Name (as shown on
                        income tax return)
                      </ControlLabel>
                      <br />
                      {federalSetting}
                      <br />
                      <Checkbox
                        inline
                        name="is_ddtax_checked"
                        onChange={this.handleInputChange}
                        value={this.state.is_ddtax_checked ? "yes" : "no"}
                      />
                      <FormControl
                        componentClass="select"
                        name="ddtax"
                        onChange={this.handleInputChange}
                        value={this.state.ddtax}
                        disabled={
                          this.state.is_ddtax_checked == 0 ? true : false
                        }
                      >
                        <option value="C_CORPORATION">
                          Limited Liability Company - C corporation
                        </option>
                        <option value="S_CORPORATION">
                          Limited Liability Company - S corporation
                        </option>
                        <option value="PARTNERSHIP">
                          Limited Liability Company - Partnership
                        </option>
                      </FormControl>
                    </FormGroup>

                    <FormGroup
                      className={validation.ssn.isInvalid && "has-error"}
                    >
                      <ControlLabel>
                        {" "}
                        <span style={{ color: "red" }}>*</span>Social Security
                        Number
                      </ControlLabel>
                      <NumberFormat
                        format="###-##-####"
                        mask="_"
                        className="form-control"
                        name="ssn"
                        placeholder="Social Security Number"
                        value={this.state.ssn}
                        onChange={this.handleInputChange}
                      />
                    </FormGroup>

                    <FormGroup
                      className={validation.address.isInvalid && "has-error"}
                    >
                      <ControlLabel>
                        {" "}
                        <span style={{ color: "red" }}>*</span>Address (number,
                        street, and apt. or suite no.)
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.address}
                        placeholder="Address"
                        onChange={this.handleInputChange}
                        name="address"
                      />
                    </FormGroup>

                    <FormGroup
                      className={validation.city.isInvalid && "has-error"}
                    >
                      <ControlLabel>
                        {" "}
                        <span style={{ color: "red" }}>*</span>City
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.city}
                        placeholder="City"
                        onChange={this.handleInputChange}
                        name="city"
                      />
                    </FormGroup>

                    <FormGroup
                      className={validation.stateName.isInvalid && "has-error"}
                    >
                      <ControlLabel>
                        {" "}
                        <span style={{ color: "red" }}>*</span>State
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.stateName}
                        placeholder="State"
                        onChange={this.handleInputChange}
                        name="stateName"
                      />
                    </FormGroup>

                    <FormGroup
                      className={validation.zipcode.isInvalid && "has-error"}
                    >
                      <ControlLabel>
                        {" "}
                        <span style={{ color: "red" }}>*</span>ZIP code
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.zipcode}
                        placeholder="ZIP code"
                        onChange={this.handleInputChange}
                        name="zipcode"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6} xs={12}>
                    <FormGroup>
                      <ControlLabel>
                        {" "}
                        Business
                        Name/disregarded entity (if different from above)
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.business_name}
                        placeholder="Business Name"
                        onChange={this.handleInputChange}
                        name="business_name"
                      />
                    </FormGroup>

                    <FormGroup>
                      <ControlLabel>
                        {" "}
                        Exempt payee code
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.expemt_payee}
                        placeholder="Exempt payee code"
                        onChange={this.handleInputChange}
                        name="expemt_payee"
                      />
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>
                        {" "}
                      Exemption from FATCA reporting code(if any)
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.exempt_report}
                        placeholder="Exemption from FATCA reporting code"
                        onChange={this.handleInputChange}
                        name="exempt_report"
                      />
                    </FormGroup>

                    <FormGroup>
                      <ControlLabel>
                        {" "}
                        Employer identification number
                      </ControlLabel>
                      <NumberFormat
                        format="##-#######"
                        mask="_"
                        className="form-control"
                        name="tin"
                        placeholder="Employer identification number"
                        value={this.state.tin}
                        onChange={this.handleInputChange}
                      />
                    </FormGroup>

                    <FormGroup>
                      <ControlLabel>
                        {" "}
                        Requesters name and address (optional)
                      </ControlLabel>
                      <FormControl
                        componentClass="textarea"
                        type="textarea"
                        value={this.state.requestersName}
                        placeholder="Requesters name and address"
                        onChange={this.handleInputChange}
                        rows="12"
                        name="requestersName"
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={6} xs={12}>
                    <FormGroup>
                      <ControlLabel>
                        {" "}
                        List account numbers (optional)
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.account_no}
                        placeholder="List account numbers"
                        onChange={this.handleInputChange}
                        name="account_no"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6} xs={12}>
                    <FormGroup
                      className={validation.wTaxFile.isInvalid && "has-error"}
                    >
                      <ControlLabel>
                        {" "}
                        <span style={{ color: "red" }}>*</span>Attach W9 file
                        <br />
                        (Attach a copy of merchants W9. Allowable filetypes are
                        JPG, PDF, PNG, TIFF, DOC and DOCX. Maximum file size is
                        20mb.)
                      </ControlLabel>
                      <FormControl
                        type="file"
                        placeholder="Business Name"
                        onChange={this.handleselectedFile}
                        name="wTaxFile"
                      />

                      <a
                        href={this.state.w9DocFileUrl}
                        id="w9DocFile"
                        target="_blank"
                      >
                        <img
                          src={this.state.w9DocFile}
                          id="w9FileImage"
                          style={{ maxHeight: "100px" }}
                        />
                      </a>
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
          <Row className="BtnRow">
            <Col md={12} xs={12}>
              <Button
                bsStyle="info"
                type="button"
                onClick={this.handleFormSubmit}
                id="saveButton"
                disabled={this.props.loading}
              >
                Save
              </Button>
              <Button
                bsStyle="default"
                onClick={() => history.push(`/merchantList`)}
              >
                Cancel
              </Button>
            </Col>
          </Row>
        </form>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    error: state.merchantReducer.error,
    merchantDetails: state.merchantReducer.merchantDetails,
    updatedMerchant: state.merchantReducer.updatedMerchant,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    loading: state.merchantReducer.loading
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        ...merchantActions,
        get_merchant_details_id,
        ...alertsActions
      },
      dispatch
    )
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(W9Info);



// WEBPACK FOOTER //
// ./src/app/views/admin/merchant/W9Info.js